/**
 * AWARE Pro Portal - Scroll Animations
 * Intersection Observer-based animation system
 */

(function() {
  'use strict';

  // Initialize scroll animations
  function initScrollAnimations() {
    const animateElements = document.querySelectorAll('[data-animate]');

    if (!animateElements.length) return;

    // Check for reduced motion preference
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion) {
      // Show all elements immediately without animation
      animateElements.forEach(el => {
        el.classList.add('is-visible');
      });
      return;
    }

    // Create intersection observer
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          // Optionally unobserve after animation
          // observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    // Observe all animated elements
    animateElements.forEach(el => observer.observe(el));
  }

  // Initialize smooth scrolling for anchor links
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const targetId = this.getAttribute('href');
        if (targetId === '#') return;

        const target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initScrollAnimations();
      initSmoothScroll();
    });
  } else {
    initScrollAnimations();
    initSmoothScroll();
  }
})();
